import { PAGE_CODES } from 'constants/pageCodes';
import { lazyWithRetry } from 'utils/chunkLoadRecovery';
import { EnhancedPath } from 'utils/history';

const LOAN_PIPELINES_ROUTING_PARAMS = {
  id: 'id',
};

export class PipelinesPaths {
  static loanPipelines = new EnhancedPath('/pipelines');

  static loanPipelinesById = new EnhancedPath(
    `${PipelinesPaths.loanPipelines.path}/:${LOAN_PIPELINES_ROUTING_PARAMS.id}?`,
  );
}

const routesConfig = {
  settings: {
    layout: {
      config: {
        toolbar: {
          display: true,
        },
        sidebar: {
          isResponsive: true,
          isOpen: false,
        },
      },
    },
  },
  routes: [
    {
      path: PipelinesPaths.loanPipelinesById.path,
      component: lazyWithRetry(() => import('app/pages/loanPipelines')),
      pageCode: PAGE_CODES.PIPELINE_LOAN_VIEW,
      exact: true,
    },
  ],
};

export default routesConfig;
